<template>  
    <section class="block block--contact">
        <div class="container h-100 contact__content text-center d-flex flex-column justify-content-center">
            <h2 v-if="block.title" class="mb-1">{{ block.title }}</h2>
            <div v-if="block.subtitle" class="subtitle">{{ block.subtitle }}</div>
            <div v-if="block.content" v-html="block.content"></div>
            <div class="mt-1">
                <a :href="`mailto:${block.email}`" class="btn btn-primary">Email Me</a>
            </div>
        </div>
        <div class="main-footer">
            <div class="container">
                <div class="small main-footer__inner">
                    <span>{{ new Date().getFullYear() }} &copy; Ramon Schumacher</span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default { 
    name: 'contact',

    props: {
        block: {
            type: Object,
            default: () => {}
        }
    }
}
</script>